/** 화면 표시용 포맷 도우미 */

export function formatNumber(value: number) {
  return value.toLocaleString('ko-KR');
}
